import { useRef } from "react";

interface Props {
  before: string;
  after: string;
}

export default function BeforeAfterSlider({ before, after }: Props) {

  const containerRef = useRef<HTMLDivElement>(null);
  const beforeRef = useRef<HTMLDivElement>(null);
  const lineRef = useRef<HTMLDivElement>(null);
  const handleRef = useRef<HTMLDivElement>(null);

  const updatePosition = (clientX: number) => {

    const rect = containerRef.current?.getBoundingClientRect();
    if (!rect) return;

    let pos = ((clientX - rect.left) / rect.width) * 100;

    pos = Math.max(0, Math.min(100, pos));

    requestAnimationFrame(() => {

      if (beforeRef.current)
        beforeRef.current.style.width = `${pos}%`;

      if (lineRef.current)
        lineRef.current.style.left = `${pos}%`;

      if (handleRef.current)
        handleRef.current.style.left = `${pos}%`;

    });

  };

  const handleMouseMove = (e: React.MouseEvent) => {
    if (e.buttons !== 1) return;
    updatePosition(e.clientX);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    updatePosition(e.touches[0].clientX);
  };

  return (

    <div
      ref={containerRef}
      onMouseMove={handleMouseMove}
      onTouchMove={handleTouchMove}
      className="
      relative
      mx-auto
      overflow-hidden
      rounded-2xl
      shadow-2xl
      w-[90%]
      md:w-[65%]
      cursor-ew-resize
      select-none
      "
    >

      {/* DOPO */}
      <img
        src={after}
        className="w-full h-full object-cover block"
      />

      {/* LABEL DOPO */}
      <div className="
        absolute top-6 right-6
        px-4 py-1.5
        text-[11px]
        tracking-[0.25em]
        text-white
        rounded-full
        backdrop-blur-xl
        bg-white/10
        border border-white/20
        shadow-[0_8px_25px_rgba(0,0,0,0.25)]
      ">
        DOPO
      </div>

      {/* PRIMA */}
      <div
        ref={beforeRef}
        className="absolute inset-0 overflow-hidden"
        style={{ width: "50%" }}
      >

        <img
          src={before}
          className="w-full h-full object-cover"
        />

        {/* LABEL PRIMA */}
        <div className="
          absolute top-6 left-6
          px-4 py-1.5
          text-[11px]
          tracking-[0.25em]
          text-white
          rounded-full
          backdrop-blur-xl
          bg-white/10
          border border-white/20
          shadow-[0_8px_25px_rgba(0,0,0,0.25)]
        ">
          PRIMA
        </div>

      </div>

      {/* LINEA */}
      <div
        ref={lineRef}
        className="
        absolute
        top-0
        bottom-0
        w-[2px]
        bg-white/90
        "
        style={{ left: "50%" }}
      />

      {/* HANDLE */}
      <div
        ref={handleRef}
        className="
        absolute
        top-1/2
        -translate-y-1/2
        w-10
        h-10
        rounded-full
        bg-white
        shadow-[0_10px_30px_rgba(0,0,0,0.35)]
        flex
        items-center
        justify-center
        transition-transform
        duration-200
        hover:scale-110
        "
        style={{ left: "50%", transform: "translate(-50%, -50%)" }}
      >

        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">

          <path
            d="M10 6L4 12L10 18"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />

          <path
            d="M14 6L20 12L14 18"
            stroke="black"
            strokeWidth="2"
            strokeLinecap="round"
          />

        </svg>

      </div>

    </div>

  );

}